<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="solucaoView">
      <div class="solucao-header page-title white" :style="'background-color:' + item.cor ">
        <div class="logotipo" :style="'border-bottom: 2px solid ' + item.cor">
          <div class="logotipo-img" :style="'background-image:url(' + item.logotipo + ');'"></div>
        </div>
      </div>
      <div class="solucao-content">
        <div class="solucao-container">
          <div class="flex flex-wrap xl:flex-row-reverse xl:pb-4 align-items-end">
            <div class="title-column w-full xl:w-6" style="padding-bottom: 20px;">
              <div class="inner-column">
                <div class="title-group" style="margin-bottom:0;">
                  <span class="sectionTitle" v-html="fc_removeHTML(item.tituloDestaque)"></span>
                  <div class="subtitulo" v-html="item.subtitulo"></div>
                  <div class="conteudo" v-html="item.conteudo"></div>
                </div>
                <div class="btn flex w-full lg:w-5 mt-3" v-if="(item.anexo != null)">
                  <div @click="fc_dialogPdf(item.anexo, item.anexoNome.toUpperCase())" class="btn-redireciona flex" v-html="fc_getText(null, 'btn_verDocumento')"></div>
                </div>
              </div>
            </div>
            <div class="image-column w-full xl:w-6 pr-0 xl:pr-5 flex align-items-center">
              <div class="inner-column">
                <div class="image-box fade-in-left">
                  <img :src="item.imagem" alt="">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Funcionalidades -->
      <div class="solucao-funcionalidades" v-if="(item.funcionalidades.length > 0)">
        <div class="auto-container">
          <div class="title-group">
            <span class="sectionTitle" v-html="fc_getText(null, 'funcionalidades')"></span>
            <div class="subtitulo" v-html="fc_getText(null, 'title_funcionalidades')"></div>
          </div>
          <div class="row">
            <div class="flex flex-wrap" style="padding-top:0px;">
              <div v-for="(forItem, forIndex) in item.funcionalidades" :key="forIndex" :item="forItem" :class="'funcionalidade flex w-full md:w-6 lg:w-4 p-2 wow ' + (forIndex % 3  == 0 || forIndex % 3 == 1 ? 'fade-in-left' : 'fade-in-right')">
                <div class="iconContainer">
                  <i :class="'icon ' + forItem.icone " :style="'color:' + item.cor + '!important;'"></i>
                </div>
                <div class="textContainer ml-1">
                  <div class="func-titulo" :style="'color: ' + item.cor" v-html="forItem.titulo"></div>
                  <div class="func-titulo-underline" :style="'background-color: ' + item.cor"></div>
                  <div class="func-descricao" v-html='forItem.descricao'></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Beneficios -->
      <div class="solucao-beneficios" style="background: #f9f9f9 !important" v-if="(item.beneficios.length > 0)">
        <div class="auto-container">
          <div class="title-group">
            <span class="sectionTitle" v-html="fc_getText(null, 'vantagens')"></span>
            <div class="subtitulo" v-html="fc_getText(null, 'title_vantagens')"></div>
          </div>
          <div class="beneficios-list">
            <div class="flex flex-wrap" style="padding-top:0px;">
              <div v-for="(forItem, forIndex) in item.beneficios" :key="forIndex" :item="forItem" :class="'beneficio flex w-full md:w-6 lg:w-4 p-2 wow ' + (forIndex % 3  == 0 ? 'fade-in-left' : (forIndex % 3 == 1 ? 'fade-zoom' : 'fade-in-right'))">
                <div class="iconContainer">
                  <i :class="'icon ' + forItem.icone " :style="'color:' + item.cor + '!important;'"></i>
                </div>
                <div class="textContainer ml-1">
                  <div class="benef-descricao" :style="'color: ' + item.cor" v-html="forItem.descricao"></div>
                  <div class="benef-titulo-underline" :style="'background-color: ' + item.cor"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <BannerContactos tipo="1" background="true" />
      <BannerOutrasSolucoes :solucao="item.id" />
    </div>
  </div>
</template>

<script>
import BannerContactos from '@/components/BannerContactos.vue';
import BannerOutrasSolucoes from '@/components/BannerOutrasSolucoes.vue';
export default {
  components: {
    BannerContactos,
    BannerOutrasSolucoes
  },
  data() {
    return {
      loaded: false,
      id: null,
      item: {}
    };
  },
  props: {},
  computed: {},
  watch: {
    '$route.params'(val) {
      if (this.$route.name == 'solucao') {
        this.id = null;
        this.item = {};
        this.mt_start();
      }
    },
  },
  methods: {
    mt_start() {
      this.id = this.$route.params.id;
      if (this.id == null) { this.fc_goRoute('solucoes'); }
      else { this.mt_loadData(); }
    },
    mt_loadData() {
      this.loaded = false;
      this.fc_fetch({ endpoint: 'Solucoes/' + this.id + '/', method: 'GET', success: this.mt_loadData_success, error: () => { this.mt_goBack(); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.item != null) {
        this.item = response.item;
        this.loaded = true;
      } else {
        this.fc_goRoute('solucoes');
      }
    },
    mt_goBack() {
      if (this.$store.state.prevRoute == null || (this.$store.state.prevRoute.name != 'solucoes')) {
        this.fc_goRoute('solucoes');
      } else {
        this.fc_goBack();
      }
    },
  },
  created() {},
  mounted() {
    this.mt_start();
  },
  unmounted() {},
};
</script>

<style scoped>
.solucao-header {
  display:flex;
  justify-content:center;
  height: 80px;
  margin-bottom: 80px;
}
.solucao-header .logotipo {
  position:absolute;
  z-index: 1;
  width:227px;
  height:124px;
  padding:10px;
  background:rgba(255,255,255,1);
  top: 0px;
  margin-top: 0px;
}
.solucao-header .logotipo-img {
  width:100%;
  height:100%;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
}
.solucao-content {
  position: relative;
}
.solucao-content .solucao-container {
  position: static;
  padding: 0px 15px 0px 0px;
  margin: 0 auto;
}
.solucao-content .solucao-container .titulo {
  position: relative;
  color: #3c4858;
  font-size: 35px;
  line-height: 43px;
  font-weight: 500;
}
.solucao-content .image-box img {
  position: relative;
  display: inline-block;
  max-width: 100%;
  height: auto;
  max-height: 500px;
  vertical-align: middle;
  border: 0;
}
.solucao-content .title-column .inner-column {
  padding-top: 50px;
}
.solucao-funcionalidades {
  padding: 100px 0px;
}
.beneficio,
.funcionalidade {
  margin-top: 40px;
}
.funcionalidade .iconContainer,
.beneficio .iconContainer {
  min-width: 50px;
}
.funcionalidade .iconContainer i,
.beneficio .iconContainer i {
  font-size: 40px;
}
.funcionalidade .func-titulo,
.beneficio .benef-descricao {
  position: relative;
  font-weight: normal;
  margin: 0px;
  background: none;
  line-height: 1.2em;
  font-size: 18px;
}
.funcionalidade .func-titulo-underline,
.beneficio .benef-titulo-underline {
  margin: 10px 0;
  width: 80px;
  height: 5px;
}
.solucao-beneficios {
  padding: 100px 0px;
}
.beneficios-list {
  margin-top:40px;
}
@media only screen and (max-width: 1200px) {
  .solucao-content .title-column .inner-column{
    padding: 0 15px;
  }
  .solucao-content .image-column .inner-column {
    margin-right: auto;
    margin-left: auto;
  }
}
@media only screen and (max-width: 1023px) {
  .solucao-content .title-column .inner-column{
    margin-left: 0;
    padding: 0;
    margin-bottom: 50px;
  }
  .solucao-content .solucao-container {
    padding: 0px 15px;
  }
}
@media screen and (max-width: 768px) {
  .solucao-content .solucao-container .titulo {
    font-size: 24px;
    line-height: 1.3em;
  }
}
@media only screen and (min-width: 1440px) {
  .solucao-content .image-column .inner-column {
    margin-left: -110px;
  }
  .solucao-content .solucao-container {
    position: static;
    max-width: 1200px;
    padding: 0px 15px;
    margin: 0 auto;
  }
}
</style>
